import { IntlProvider } from 'preact-i18n'
import { createContext, ComponentChildren } from 'preact'
import { useSignal } from '@preact/signals'
import { useContext, useEffect } from 'preact/hooks'
import AppStore from './AppStore'
import TranslationLoader from './TranslationLoader'
import { useTracker } from './TrackerProvider'

const AppContext = createContext<AppStore>({} as AppStore)

const Provider = ({ children, store }: { children: ComponentChildren; store: AppStore }) => {
  const translations = useSignal<undefined | {}>({})
  const tracker = useTracker()
  useEffect(() => {
    ;(async function () {
      try {
        const definitions = await TranslationLoader()
        translations.value = definitions.default ? definitions.default : definitions
        store.injectTracker(tracker)
      } catch (error: any) {
        store.errorsStore.handleError(error)
      }
    })()
  }, [store, tracker])

  return (
    <IntlProvider definition={translations.value}>
      <AppContext.Provider value={store}>{children}</AppContext.Provider>
    </IntlProvider>
  )
}

export const useStore = () => {
  return useContext(AppContext)
}

export default Provider
